<template>
	<div>
		<router-view />
		<!-- 加载动画 -->
		<z-loading v-model="loading" />
	</div>
</template>

<script>
// 加载动画
import zLoading from "@/components/common/loading";
import { mapState, mapMutations } from "vuex";
import { getKefu,getBalance,getQewm } from "@/config/api";
export default {
	name: "App",
	components: {
		zLoading,
	},
	computed: {
		...mapState(["loading","showLogin"]),
	},
	created() {
		this.setCacheData();
		getKefu()
		getBalance()
		getQewm()
	},
	methods: {
		...mapMutations(["setCacheData"]),
	},
	mounted() {},
};
</script>

<style lang="scss">
@import "@/styles/common.scss";
@import "@/styles/main.scss";
@import "@/styles/uview.scss";
@import "@/styles/iconfont.scss";
.el-card__body, .el-main {
    padding: 16px;
}
$--color-primary: #1A8BD2;

.biaoqian {
  padding: 10px 0px 10px 0px;
  font-size: 13px;
  color: rgb(104, 104, 104)
}

.newdialog {
  top: -7%;
  width: 92% !important;
  max-width: 700px;
  min-width: 350px;
}

.newdialog_share {
  width: 90% !important;
  max-width: 500px;
  min-width: 350px;
}
.newdialog_dir{
  width: 90% !important;
  max-width: 900px;
  min-width: 350px;
}
.msbox {
  width: 80% !important;
  max-width: 400px !important;
}
</style>
